var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.me.photo)?_c('div',[_c('img',{staticStyle:{"height":"150px"},attrs:{"src":_vm.me.photoUrl}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }